import { createFileRoute } from '@tanstack/react-router'
import { ExecutiveSummaryTab } from '@/features/incidents/reports/executive-summary/executive-summary-tab'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/executive-summary'
)({
  component: ExecutiveSummaryTab,
})
